import { UseMutationOptions, useMutation } from "@tanstack/react-query"
import api from "services/api"
import { IMemberEmailRegistrationForm } from "./use-form"
import { AxiosError } from "axios"

export function useRegisterMemberEmail(
  config?: UseMutationOptions<unknown, AxiosError, IMemberEmailRegistrationForm>
) {
  return useMutation<unknown, AxiosError, IMemberEmailRegistrationForm>(
    (data) =>
      api.post(
        "operation/administration/members/external/generate-verification-token",
        data
      ),
    {
      meta: { handleError: false },
      ...config,
    }
  )
}
